import script from "./Wingo.vue?vue&type=script&setup=true&lang=js"
export * from "./Wingo.vue?vue&type=script&setup=true&lang=js"

import "./Wingo.vue?vue&type=style&index=0&id=137bc336&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-137bc336"]])

export default __exports__